import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivateFn, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {UserProfileService} from "../service/user-profile.service";
import {Location} from "@angular/common";

export const settingsUpdateGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const userProfileService = inject(UserProfileService);
  const location = inject(Location);
  const router = inject(Router);

  const currentPath = location.path();

  if (currentPath.includes('update-phone') && !userProfileService.phone ) {
    router.navigate(['ds/us']);
    return false;
  } else if(currentPath.includes('update-email') && !userProfileService.email) {
    router.navigate(['ds/us']);
    return false;
  } else {
    return true;
  }
};
